import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { AvatarComponent } from '../../../components/avatar/avatar.component';
import { SectionTitleComponent } from '../../../components/section-title/section-title.component';
import { TcStatusPillComponent } from '../../../components/tc-status-pill/tc-status-pill.component';
import { DEVOPS_CI_BUILDS, DEVOPS_INCIDENTS } from '../../models/devops-mock.data';

@Component({
  selector: 'app-devops-builds-incidents',
  imports: [MatIcon, MatTooltip, TranslatePipe, AvatarComponent, SectionTitleComponent, TcStatusPillComponent],
  templateUrl: './devops-builds-incidents.component.html',
  styleUrl: './devops-builds-incidents.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevOpsBuildsIncidentsComponent {
  protected readonly builds = DEVOPS_CI_BUILDS;
  protected readonly incidents = DEVOPS_INCIDENTS;
}
